
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"20","viewBox":"0 0 17 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.5 19H2.643C1.735 19 1 18.105 1 17V3c0-1.105.735-2 1.643-2H13.32c.908 0 1.643.895 1.643 2v6.5M5.714 6.25h5.5M5.714 10.25h2.5","stroke":"#262626","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M15.5 13L10 18.5M15.5 18.5L10 13","stroke":"#DB2121","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    